import { Link, useRouteError } from "react-router";
import { useT } from "../../i18n/I18nProvider";
import { EmptyState, ErrorState } from "../../ui/feedback";

export function NotFoundPage() {
  const t = useT();
  return (
    <EmptyState icon="search" title={t("notFound.title")} action={<Link to="/">{t("notFound.home")}</Link>}>
      {t("notFound.body")}
    </EmptyState>
  );
}

export function RouteError() {
  const error = useRouteError();
  return (
    <div className="cc-center">
      <ErrorState error={error} onRetry={() => window.location.reload()} />
    </div>
  );
}
